module.exports = __webpack_public_path__ + "static/media/bg6.ac66acd9.jpg";